import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HtmlViewerComponent } from 'src/app/popups/html-viewer/html-viewer.component';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, KeyValueSet, LocalService, PageKey, Wrappers15 } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';

@Component({
  selector: 'app-rent-recipt-logs',
  templateUrl: './rent-recipt-logs.component.html',
  styleUrls: ['./rent-recipt-logs.component.scss']
})
export class RentReciptLogsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["rent_recipt_logs"]; interactionTypes: KeyValueSet[] = [];
  ctryCode: string = ''; userId: string = ''; interactionType: InteractionType;
  wrapper: Wrappers15; maxBodyHeight = 0;
  selectedCountryCode = ''; selectedIntercationType = ''; selectedCountryId = '';
  reqTimeStamp = ''; reqCountryId = ''; reqStateId = ''; reqDistrictId = ''; reqConstituencyId = '';
  IsPrint: boolean = false; printContent: string = ''; fileName: string = '';

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute, private profileManagementService: ProfileManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);

    this.interactionTypes.push({ key: InteractionType.Business.toString(), value: InteractionType[InteractionType.Business] } as KeyValueSet);
    this.interactionTypes.push({ key: InteractionType.ServiceProvider.toString(), value: InteractionType[InteractionType.ServiceProvider] } as KeyValueSet);
    this.selectedIntercationType = this.interactionTypes[0].key;

    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      if (this.selectedCountryCode == '')
        this.selectedCountryCode = this.ctryCode;
      if (this.interactionType == InteractionType.Bill_PnixSoft) {
        this.reqTimeStamp = routeParams.reqTimestamp;
        this.reqCountryId = routeParams.reqCtryId;
        this.reqStateId = routeParams.reqStateId;
        this.reqDistrictId = routeParams.reqDistrictId;
        this.reqConstituencyId = routeParams.reqConstituencyId;
        this.configurationManagementService.ensurePageActions(PageKey.RentReceiptLogs);
        if (this.reqCountryId == '0')
          this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.reqCountryId == '0')
      this.selectedCountryId = this.localService.getCountryIdByCountryCode(this.selectedCountryCode);
    this.profileManagementService.getRentReceiptLogs(this.selectedCountryCode, parseInt(this.selectedIntercationType), this.reqCountryId, this.reqStateId, this.reqDistrictId, this.reqConstituencyId, this.reqTimeStamp, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }

  onOpenInvoice(id, index: number) {
    this.profileManagementService.getInvoice(id, this.selectedCountryCode, index != 1).subscribe(result => {
      switch (index) {
        case 1: {
          const modalRef = this.modalService.open(HtmlViewerComponent, { size: 'lg' });
          modalRef.componentInstance.content = result.value;
          modalRef.componentInstance.isPopUp = true;
        } break;
        case 2: {
          this.fileName = result.key;
          this.IsPrint = true;
          this.printContent = result.value;
        } break;
      }
    });
  }

  onPrinted() {
    this.IsPrint = false;
  }
}
